import { queryClient } from '@/libs/tanstack-query';
import { QueryClientProvider } from '@tanstack/react-query';

interface TanstackReactQueryProviderProps {
  children: React.ReactNode;
}

export default function TanstackReactQueryProvider({
  children,
}: TanstackReactQueryProviderProps) {
  return (
    <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
  );
}
